import gql from "graphql-tag";

const SPENDING_DATA = gql`
  fragment SpendingData on Spending {
    id
    amount
    note
    date
    currency {
      id
      name
    }
    category {
      id
      name
      type
    }
  }
`;

export const GET_SPENDINGS = gql`
  query(
    $categoryId: ID
    $startDate: String
    $endDate: String
    $timezoneOffset: Int
    $offset: Int
    $limit: Int
  ) {
    spendings(
      categoryId: $categoryId
      startDate: $startDate
      endDate: $endDate
      timezoneOffset: $timezoneOffset
      offset: $offset
      limit: $limit
    ) {
      ...SpendingData
    }
  }
  ${SPENDING_DATA}
`;

export const GET_OPTIONS = gql`
  query {
    currencies {
      id
      name
    }
    categories {
      id
      name
      type
    }
  }
`;

export const GET_NOTE_SUGGESTIONS = gql`
  query($categoryId: ID) {
    noteSuggestions(categoryId: $categoryId)
  }
`;

export const GET_SPENDING_MONTHS = gql`
  query($timezoneOffset: Int) {
    spendingMonths(timezoneOffset: $timezoneOffset) {
      month
      count
    }
  }
`;

export const ADD_SPENDING = gql`
  mutation AddSpending(
    $amount: Float!
    $note: String!
    $categoryId: ID!
    $currencyId: ID!
    $date: String!
  ) {
    addSpending(
      amount: $amount
      note: $note
      categoryId: $categoryId
      currencyId: $currencyId
      date: $date
    ) {
      ...SpendingData
    }
  }
  ${SPENDING_DATA}
`;

export const UPDATE_SPENDING = gql`
  mutation UpdateSpending(
    $id: ID!
    $amount: Float!
    $note: String!
    $categoryId: ID!
    $currencyId: ID!
    $date: String!
  ) {
    updateSpending(
      id: $id
      amount: $amount
      note: $note
      categoryId: $categoryId
      currencyId: $currencyId
      date: $date
    ) {
      ...SpendingData
    }
  }
  ${SPENDING_DATA}
`;

export const DELETE_SPENDING = gql`
  mutation DeleteSpending($id: ID!) {
    deleteSpending(id: $id)
  }
`;
